import { ArrowUpRight, CircleCheck, Radar, ShieldAlert, Sparkles, Zap } from "lucide-react";
import "./OperationsCommandPreview.css";

export default function OperationsCommandPreview() {
  return (
    <section className="operations-preview" data-testid="operations-command-preview">
      <header className="operations-preview-header">
        <div>
          <span className="preview-kicker"><Sparkles size={12} />OPERATIONS INTELLIGENCE</span>
          <h2>Every post-purchase signal, in context.</h2>
        </div>
        <span className="preview-live"><i />Analyzing live</span>
      </header>
      <div className="operations-flow" data-testid="operations-flow-signals">
        <span>Returns</span><i /><span>Refunds</span><i /><span>Exchanges</span><i /><span>Recovery</span>
      </div>
      <div className="operations-signal-grid">
        <article className="signal-card signal-card-priority" data-testid="preview-refund-risk">
          <span className="signal-icon"><ShieldAlert size={16} /></span>
          <div><small>Refund risk detection</small><strong>2 requests need review</strong><p>Policy variance identified</p></div>
          <b className="risk-chip">Review</b>
        </article>
        <article className="signal-card" data-testid="preview-recovery-opportunity">
          <span className="signal-icon signal-icon-cyan"><ArrowUpRight size={16} /></span>
          <div><small>Customer recovery</small><strong>$3,240 protected</strong><p>8 high-value opportunities</p></div>
        </article>
        <article className="signal-card signal-card-wide" data-testid="preview-ai-recommendation">
          <span className="signal-icon signal-icon-blue"><Radar size={16} /></span>
          <div><small>DEEWEL intelligence</small><strong>Policy-aligned path found</strong><p>Inventory, risk, and customer value are aligned for a retained-revenue outcome.</p></div>
          <span className="confidence-block"><b>98%</b><small>confidence</small></span>
        </article>
      </div>
      <footer className="operations-preview-footer">
        <span><CircleCheck size={14} />24 live requests</span>
        <span><Zap size={14} />78% automated</span>
        <strong>Revenue protected <b>$12.4K</b></strong>
      </footer>
    </section>
  );
}